<slider></slider>
<welcome></welcome>
